import { render, staticRenderFns } from "./TaskField.vue?vue&type=template&id=c407369e&"
import script from "./TaskField.vue?vue&type=script&lang=js&"
export * from "./TaskField.vue?vue&type=script&lang=js&"
import style0 from "./TaskField.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/TaskField.vue
// module id = 1140
// module chunks = 0